import React from 'react';
import { Badge, BadgeProps } from '@/components/ui/badge';

type Props = Pick<BadgeProps, 'pill'> & {
  className?: string;
  variant?: Exclude<BadgeProps['variant'], 'transparent'>;
  children?: React.ReactNode;
};

const SoftBadge = React.forwardRef<HTMLSpanElement, Props>(
  ({ className, variant = 'primary', children, ...rest }, ref) => (
    <Badge ref={ref} variant={variant} soft className={className} {...rest}>
      {children}
    </Badge>
  ),
);
SoftBadge.displayName = 'SoftBadge';

export default SoftBadge;
